var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProh(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 203,
    viewBox: "0 0 203 203",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M154.801 64.5103L44.0624 64.5098C39.7483 64.5098 36.251 68.0071 36.251 72.3212V147.091C36.251 149.866 38.5006 152.116 41.2757 152.116H43.8497",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6973 152.116H161.171C163.946 152.116 166.196 149.866 166.196 147.091V72.4815C166.196 70.5711 165.808 68.9932 164.687 67.6202",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M157.361 66.1763C157.329 66.1468 155.416 64.6795 154.431 64.5103H43.19C39.3561 64.5103 36.252 67.617 36.252 71.4485V72.5521H155.534C155.546 72.4713 157.264 70.0729 157.806 68.8179C157.852 68.6335 157.364 66.1796 157.361 66.1763ZM41.6121 70.2985C40.6994 70.2985 39.9569 69.5586 39.9569 68.6458C39.9569 67.7306 40.6994 66.9906 41.6121 66.9906C42.5248 66.9906 43.2648 67.7306 43.2648 68.6458C43.2648 69.5586 42.5248 70.2985 41.6121 70.2985ZM47.0961 70.2985C46.1808 70.2985 45.4409 69.5586 45.4409 68.6458C45.4409 67.7306 46.1808 66.9906 47.0961 66.9906C48.0088 66.9906 48.7488 67.7306 48.7488 68.6458C48.7488 69.5586 48.0088 70.2985 47.0961 70.2985ZM52.5775 70.2985C51.6648 70.2985 50.9248 69.5586 50.9248 68.6458C50.9248 67.7306 51.6648 66.9906 52.5775 66.9906C53.4928 66.9906 54.2327 67.7306 54.2327 68.6458C54.2327 69.5586 53.4928 70.2985 52.5775 70.2985Z",
    fill: "#0E171E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M164.78 67.2539C164.69 67.8719 164.519 68.4933 164.371 69.1233C164.089 70.3203 164.043 71.5253 163.445 72.552H166.196V71.4485C166.196 69.8712 165.667 68.4191 164.78 67.2539Z",
    fill: "#0E171E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M116.89 54.3844C117.136 54.7604 117.165 55.1841 116.966 55.4446C116.931 55.4904 116.801 55.6462 116.593 55.6704C116.318 55.7023 116.019 55.492 115.875 55.1336",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M113.708 56.2557C114.02 56.6641 114.071 57.1378 113.86 57.416C113.84 57.4428 113.708 57.6121 113.487 57.6418C113.169 57.6848 112.806 57.4184 112.639 56.9591",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M114.736 56.1043C114.814 56.2046 114.95 56.2367 115.06 56.183C115.178 56.1254 115.235 55.9832 115.189 55.8551",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M119.174 53.6907L122.894 51.3868",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M119.707 54.8245L123.916 53.1948",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M110.182 57.9847L106.299 60.002",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M110.882 59.0225L107.328 61.805",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M126.86 55.4451C132.174 51.0698 137.001 48.7829 140.602 47.6227C145.011 46.2021 149.809 46.3723 154.017 48.3085C164.222 53.0061 164.634 64.5103 164.634 64.5103C164.634 64.5103 165.093 69.166 163.304 73.7198C160.038 82.0334 152.31 86.9206 148.92 86.5623C148.598 86.5288 147.698 86.4334 146.966 85.7629C145.607 84.5229 145.883 82.2875 145.927 81.9678C146.081 80.8539 146.553 80.0597 146.731 79.7762C149.479 75.3854 156.688 73.604 157.598 69.1331C157.704 68.6046 157.851 67.4212 157.25 66.3383C156.699 65.3432 155.724 64.8016 154.801 64.5103H106.943C106.255 61.5685 109.106 60.7872 109.106 60.7872C112.986 61.0834 117.051 60.1455 120.166 59.123",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M127.232 56.951C127.232 56.951 126.711 51.0313 119.707 50.0109L115.374 46.8406C114.852 46.4588 114.118 46.8314 114.118 47.478V50.4245L111.931 51.8277L109.026 50.788C108.435 50.5766 107.862 51.1404 108.062 51.7347L109.106 54.8244C109.106 54.8244 107.254 58.3066 109.106 60.7878",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M120.66 64.28C120.66 64.28 120.522 61.1095 127.966 60.8798C135.41 60.65 139.362 53.1948 139.362 53.1948C139.362 53.1948 141.292 49.3005 143.681 49.0708",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0331 102.401C95.9139 102.613 94.9692 102.662 94.3041 102.671C94.1112 103.579 93.6602 105.565 93.6602 105.565",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2969 105.395C81.2969 105.395 83.1152 97.9542 83.6317 96.4699C81.4925 94.2231 81.4111 92.2094 82.1486 90.931C82.1935 90.8514 82.5346 90.2844 83.1631 90.1328C83.7539 89.9919 84.2757 89.5872 85.0263 90.1381L95.4423 85.4574L96.7947 88.5366",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5762 92.2931C94.8004 93.0143 95.0972 93.5097 95.3348 93.8349C95.5271 94.0983 95.7429 94.3352 95.7835 94.7084C95.8219 95.0618 95.6851 95.3699 95.5604 95.5782",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9414 96.385C91.1464 96.6593 91.6005 97.1886 92.3712 97.5394C92.9958 97.8237 93.5603 97.8687 93.8879 97.8698",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0605 92.3174C84.2058 92.6376 84.3951 92.9972 84.6429 93.374C84.9844 93.8932 85.3441 94.304 85.6603 94.6178",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0957 91.1368C96.1362 91.2528 96.2073 91.413 96.3342 91.5775C96.4248 91.6948 96.519 91.7821 96.5977 91.8448",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3809 93.3268C91.5461 93.2153 91.7106 93.191 91.7942 93.1847",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0273 93.8385C91.0453 93.7667 91.1209 93.5019 91.3804 93.3268",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0827 105.608C91.2536 105.624 92.4159 105.768 93.5831 105.838L94.261 102.501C94.261 102.501 90.7443 102.724 88.986 102.836C88.2904 102.88 87.9587 103.713 88.4336 104.223L89.901 105.634C89.9566 105.618 90.0157 105.607 90.0827 105.608Z",
    fill: "#0E171E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1669 83.0866C98.5284 83.1761 99.7122 83.9016 100.225 85.002C101.004 86.6753 99.9853 88.6906 98.5237 89.5091C96.852 90.4452 94.486 89.8794 93.2 88.01C92.9881 88.5573 92.5545 89.4323 91.6756 90.1242C89.9971 91.4455 87.8567 91.1837 87.4463 91.1335C85.3259 90.8743 84.5689 89.6996 83.3613 90.2103C82.5212 90.5656 82.201 91.4243 82.1412 91.5974C81.6694 92.9642 82.6188 95.5004 83.6626 96.2357C84.0883 96.5355 82.9629 100.943 81.135 97.4048C78.5565 93.5964 78.0821 87.3757 79.7055 85.8126C80.0344 85.4959 80.678 85.0441 81.9172 84.9542C80.9854 83.8477 80.9458 82.246 81.7964 81.134C82.7049 79.9462 84.4103 79.6028 85.7534 80.3751C85.826 78.6697 87.2698 77.4632 88.6609 77.6088C89.7565 77.7235 90.729 78.6673 90.9482 79.9307C91.9215 78.442 93.8763 77.9154 95.4597 78.7098C97.0539 79.5095 97.7981 81.4108 97.1669 83.0866Z",
    fill: "#0E171E"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4894 152.013L54.4008 155.551C47.3411 158.631 40.2025 151.381 43.3916 144.37L57.5291 113.288C58.4783 111.201 60.5593 109.862 62.8518 109.862H77.8349L79.6251 105.395L95.1819 105.739L93.8864 109.723L109.665 109.679C113.074 109.669 116.124 111.796 117.293 114.999L128.88 146.744C129.902 149.545 127.938 152.018 124.956 151.974L93.0441 151.997L62.4894 152.013Z",
    stroke: "#0E171E",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2179 105.565L81.4277 110.032",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4504 105.688L85.6602 110.155",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1301 105.688L90.3398 110.155",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5684 139.463L110.596 139.463",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M108.357 139.434L103.801 125.45",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1233 139.463L92.4433 152.116H66.9201C65.243 151.196 73.1838 147.636 73.1838 147.636",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9176 150.937C64.5239 151.697 64.9349 152.135 66.7833 152.116",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M92.085 139.462L92.4433 152.116H88.6914L92.085 139.462Z",
    fill: "#0E171E"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4811 123.837L105.142 110.847L101.661 109.304L93.2715 125.674",
    stroke: "#0E171E",
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M122.44 96.4241C122.44 103.602 116.624 109.418 109.446 109.418C102.27 109.418 96.4512 103.602 96.4512 96.4241C96.4512 89.2488 102.27 83.4296 109.446 83.4296C116.624 83.4296 122.44 89.2488 122.44 96.4241Z",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M98.25 83.9639L99.5132 88.1139C100.001 89.681 100.865 92.0599 101.817 94.998C104.352 102.822 103.669 103.636 102.578 104.77C102.158 105.206 101.397 105.517 100.362 105.669",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0977 92.5874C96.275 93.5453 96.5797 94.225 96.8345 94.6778C97.0408 95.0445 97.281 95.3808 97.2761 95.865C97.2716 96.3235 97.0494 96.6973 96.8579 96.9451",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2207 91.3379C98.2549 91.4926 98.3215 91.7087 98.4591 91.9386C98.5572 92.1027 98.6645 92.2289 98.7558 92.3211",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M101.58 89.6227C100.557 90.0455 99.4018 90.0608 98.3164 89.7154C99.7525 87.3383 101.931 85.4562 104.527 84.3939C105.051 86.5726 103.491 88.8311 101.58 89.6227Z",
    fill: "#0E171E"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M109.445 81.3773C107.339 81.3773 105.333 81.8104 103.513 82.5942C100.579 83.8526 98.1241 86.0207 96.5049 88.7435C95.1668 90.9917 94.3984 93.6191 94.3984 96.4242C94.3984 104.737 101.135 111.471 109.445 111.471C117.755 111.471 124.492 104.737 124.492 96.4242C124.492 88.1143 117.755 81.3773 109.445 81.3773ZM109.445 109.419C102.27 109.419 96.4507 103.602 96.4507 96.4242C96.4507 93.9695 97.1314 91.675 98.3149 89.7154C99.7509 87.3383 101.93 85.4562 104.526 84.3939C106.042 83.7725 107.705 83.4296 109.445 83.4296C116.623 83.4296 122.44 89.2488 122.44 96.4242C122.44 103.602 116.623 109.419 109.445 109.419Z",
    fill: "#0E171E"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0586 114.433L102.34 116.106",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7246 113.081L103.033 114.767",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0247 134.72L80.7116 127.725L86.4192 141.413L61.1426 152.609",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8052 125.837L66.7969 133.215",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1849 123.908L96.5527 126.973C96.5527 126.973 99.2821 126.95 98.1849 123.908Z",
    fill: "#0E171E"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9192 127.437L94.1018 123.692C94.4005 121.9 89.0015 124.305 89.0015 124.305L80.9297 127.537L86.5202 141.096L94.4005 137.822C99.0873 136.053 98.3226 134.39 98.3226 134.39",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1602 125.307C93.1602 125.307 93.9432 127.937 96.9752 127.017C97.5075 126.855 97.9761 126.5 98.2225 126.001C98.407 125.628 98.4885 125.161 98.1879 124.685C97.9202 124.262 98.2648 123.716 98.7631 123.764C98.9932 123.787 99.2807 123.873 99.6391 124.06C100.379 124.446 100.734 125.078 100.884 125.731C101.328 127.656 100.019 129.571 98.0775 129.939C97.2405 130.098 96.1641 130.096 94.7907 129.781",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M100.08 128.801C100.08 128.801 101.454 134.157 94.4004 132.492",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6004 131.86C99.6198 133.034 99.105 135.643 93.9648 134.852",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1094 127.606L86.4195 141.096L88.7261 140.055L81.1094 127.606Z",
    fill: "#0E171E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProh);
export default __webpack_public_path__ + "static/media/proh.bbe57f7e7b17160d8c817ffad11061df.svg";
export { ForwardRef as ReactComponent };